<template>
  <div>
    <div class="main_box">
      <div>
        <!--操作栏-->
        <el-form @submit.native.prevent :inline="true">
          <el-form-item>
            <el-form-item label="用户名称：" prop="date">
              <el-input v-model="searchForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="date">
              <el-input v-model="searchForm.mobile" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="账号启用状态：" prop="status">
              <el-select
                v-model="searchForm.enableStatus"
                placeholder="请选择"
                filterable
                :clearable="true"
              >
                <el-option
                  v-for="(item, key) in statusList"
                  :key="key"
                  :label="item"
                  :value="key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-button type="primary" @click="loadData">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button icon="el-icon-plus" @click="save()" type="primary">添加</el-button>
    </div>
    <div class="main_box_table">
      <el-table :data="dataList" border>
        <el-table-column prop="id" label="用户编号"></el-table-column>
        <el-table-column prop="account" label="用户账号"></el-table-column>
        <el-table-column prop="name" label="用户姓名"></el-table-column>
        <el-table-column prop="roleName" label="角色"></el-table-column>
        <el-table-column prop="mobile" label="联系电话"></el-table-column>
        <el-table-column prop="" label="启用状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enableStatus"
              active-value="1"
              inactive-value="0"
              @change="changeStatus(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间 "></el-table-column>
        <el-table-column fixed="right" width="320px" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="save(scope.row)" icon="el-icon-edit">修改</el-button>
            <el-button type="text" @click="deleteRole(scope.row)" icon="el-icon-delete">删除</el-button>
            <el-button type="text" @click="resetPassWord(scope.row)" icon="el-icon-circle-check">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex-r-e">
        <el-pagination
          v-show="total > 0"
          background=""
          layout="prev, pager, next, sizes, total, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="dialogTitle == 0 ? '添加用户' : '编辑用户'"
      :visible.sync="roleDialogVisible"
      append-to-body
    >
      <el-form
        :model="currentRole"
        ref="currentRole"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="登录帐号：" prop="account">
              <el-input placeholder="请输入" v-model="currentRole.account"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名：" prop="name">
              <el-input placeholder="请输入" v-model="currentRole.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="mobile">
              <el-input placeholder="请输入" v-model="currentRole.mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属角色：" prop="roleId">
              <el-select
                style="width: 100%"
                v-model="currentRole.roleId"
                placeholder="请选择"
                filterable
                :clearable="true"
                @close="dialogClose"
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
        </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose" class="cancel-btn"
        >取 消
        </el-button
        >
        <el-button type="primary" @click="submitRole('currentRole')"
        >确 定
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api";

var _self;
export default {
  data() {
    return {
      //分页
      pageNum: 1,
      pageSize: 10,
      total: 0,
      statusList: {
        "0": "未启用",
        "1": "启用"
      },
      searchForm: {
        name: "",
        enableStatus: "",
        mobile: ""
      },
      dataList: [],
      //弹窗
      roleDialogVisible: false,
      dialogTitle: 0, //新建为0，编辑为1
      currentRole: {
        account: "",
        name: "",
        roleId: "",
        mobile: ""
      },
      menuDialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: "名称不能为空！",
            trigger: "blur"
          }
        ],
        account: [
          {
            required: true,
            message: "账号不能为空！",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "密码不能为空！",
            trigger: "blur"
          }
        ],
        roleId: [
          {
            required: true,
            message: "角色不能为空！",
            trigger: "blur"
          }
        ],
        mobile: [
          {
            required: true,
            message: "手机号不能为空！",
            trigger: "blur"
          }
        ]
      },
      roleList: []
    };
  },

  created() {
    _self = this;
  },
  mounted() {
    _self.loadData();
    _self.getRolesList();
  },
  methods: {
    dialogClose() {
      _self.roleDialogVisible = false;
      if (_self.$refs.currentRole) {
        _self.$refs.currentRole = _self.$options.data().currentRole;
      }
    },
    dateChange() {
      if (_self.searchForm.applyDate == null) _self.searchForm.applyDate = [];
    },
    // 每页多少条
    handleSizeChange(val) {
      _self.pageSize = val;
      _self.loadData();
    },
    // 当前页
    handleCurrentChange(val) {
      _self.pageNum = val;
      _self.loadData();
    },
    loadData() {
      let param = {
        pageNum: _self.pageNum - 1,
        pageSize: _self.pageSize,
        ..._self.searchForm
      };
      api.userAPI
        .findAll(param)
        .then(res => {
          if (res.status == 200) {
            if (res.data.content.length == 0 && res.data.total != 0) {
              _self.pageNum -= 1;
              _self.loadData();
              return;
            }
            _self.dataList = res.data.content;
            _self.total = res.data.total;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    reset() {
      _self.searchForm = _self.$options.data().searchForm;
      _self.loadData();
    },
    //添加
    save(row) {
      if (row) {
        //编辑
        _self.dialogTitle = 1;
        _self.currentRole = JSON.parse(JSON.stringify(row));
      } else {
        //添加
        _self.dialogTitle = 0;
        _self.currentRole = this.$options.data().currentRole;
      }
      _self.roleDialogVisible = true;
    },
    submitRole() {
      this.$refs["currentRole"].validate(valid => {
        if (valid) {
          if (_self.dialogTitle == 0) {
            api.userAPI
              .createUserInfo(_self.currentRole)
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.roleDialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            api.userAPI
              .updateUserInfo(_self.currentRole)
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.roleDialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteRole(row) {
      _self
        .$confirm("此操作将永久删除此项, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          row.deleteFlg = "1";
          api.userAPI
            .deleteUserInfo(row)
            .then(res => {
              if (res.status == 200) {
                this.$message.success("操作成功");
                _self.loadData();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {

        });
    },
    async getRolesList() {
      let res = await api.roleAPI.findAllRoles();
      if (res.status == 200) {
        _self.roleList = res.data.map(it => {
          return {
            value: it.id,
            label: it.name
          };
        });
      }
      console.log(res);
    },
    async resetPassWord(row) {
      let res = await api.userAPI.updatePassword({ id: row.id });
      if (res.status == 200) {
        this.loadData()
        this.$message.success("操作成功");
      }
    },
    changeStatus(row) {
      console.log(row);
      _self
        .$confirm("此操作将禁用/启用此项, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          api.userAPI
            .updateUserInfo(row)
            .then(res => {
              if (res.status == 200) {
                this.$message.success("操作成功");
                _self.loadData();
                _self.roleDialogVisible = false;
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
    },
  }
};
</script>
<style lang="scss" scoped></style>
